import type { Discrepancy } from '../../types/discrepancy';
import { DISCREPANCY_STATUS_LABELS } from '../../types/discrepancy';

interface StatusBadgeProps {readonly status: Discrepancy['status'];}

const STATUS_CONFIG: Record<Discrepancy['status'], {
  bg: string;
  text: string 
}> = {
  open: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  },
  pending_supplier_response: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
  },
  pending_receiver_confirmation: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
  },
  resolved: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
  },
  disputed: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  },
};

const DEFAULT_CONFIG = {
  bg: 'bg-slate-100',
  text: 'text-slate-600',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const {
    bg, text 
  } = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;

  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${bg} ${text}`}>
      {DISCREPANCY_STATUS_LABELS[status]}
    </span>
  );
}
